<template>
  <div class="document-container">
    <div class="document">
      <div class="header">
        <EsHeader>
          <template #header>
            <div class="header-title">
              <font-awesome-icon :icon="['fas', 'shield-check']"/>
              Role Privilege Settings
            </div>
            <div class="header-subtitle">
              Click one or more checkboxes to assign privileges to this role.
              This page uses an autosave feature. Your changes are saved automatically in real-time.
            </div>
          </template>
          <template #actions>
            <div class="action" >
              <ul>
                <li class="removeBorder">
                  <a
                    class="has-text-weight-bold"
                    role="button"
                    tabindex="0"
                    :class="{ 'disabled': isDisabled && isExpand }"
                    @click='expand(true)'
                    @keypress='expand(true)'
                  >
                    Expand All
                  </a>
                </li>
                <li>
                  <a
                    class="has-text-weight-bold"
                    role="button"
                    tabindex="0"
                    :class="{ 'disabled': isDisabled && !isExpand }"
                    @click='expand(false)'
                    @keypress='expand(false)'
                  >
                    Collapse All
                  </a>
                </li>
              </ul>
            </div>
          </template>
        </EsHeader>
      </div>
      <div class="content">
        <es-loader v-if="loading"/>
        <div v-else>
          <table class="table is-hoverable is-fullwidth">
            <security-manager-privilege-setting
              v-for="(privilege,index) in privileges"
              :expand="isListStatus[index]"
              :id="index"
              :key="index"
              :privilege="privilege"
              @onExpand="onExpand"
              @updateHeader="refreshHeader"
            />
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCaretDown,
  faCaretUp,
} from '@fortawesome/pro-light-svg-icons';
import {
  faShieldCheck,
} from '@fortawesome/pro-solid-svg-icons';
import EsHeader from '@/components/EsHeader.vue';
import { mapActions } from 'vuex';
import EsLoader from '@/components/EsLoader.vue';
import SecurityManagerPrivilegeSetting from '@/components/SecurityManagerPrivilegeSetting.vue';
import BreadcrumbsManager from '@/mixins/BreadcrumbManager';
import NotificationManager from '@/mixins/NotificationManager';

library.add(
  faCaretDown,
  faCaretUp,
  faShieldCheck,
);

export default {
  mixins: [BreadcrumbsManager, NotificationManager],
  components: {
    EsHeader,
    EsLoader,
    SecurityManagerPrivilegeSetting,
  },
  data() {
    return {
      isExpand: false,
      loading: false,
      privileges: [],
      isDisabled: true,
      isListStatus: [],
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    ...mapActions(['getPrivileges']),
    async fetchData() {
      this.toggleLoading();
      try {
        const { roleId } = this.$route.params;
        await this.getPrivileges(roleId).then((response) => {
          const list = response.data;
          this.privileges = list.sort((a, b) => a.description.localeCompare(b.description));
        });
      } catch (error) {
        this.apiMsg = `${error.response.status === 500 ? 'Network Error' : error.response.data.message}`;
        this.showNotification('danger', [this.apiMsg]);
      }
      this.toggleLoading();
    },
    toggleLoading() {
      this.loading = !this.loading;
    },
    refreshHeader() {
      this.$emit('updateHeader');
    },
    expand(val) {
      const temp = [];
      this.privileges.forEach((item, i) => {
        temp[i] = val;
      });
      this.isListStatus = [...temp];
      this.updateExpand();
    },
    onExpand(id, isExpand) {
      this.isListStatus[id] = isExpand;
      this.isListStatus = [...this.isListStatus];
      this.updateExpand();
    },
    updateExpand() {
      const total = this.privileges.length;
      const checked = this.isListStatus.filter((item => item)).length;
      const unChecked = this.isListStatus.filter((item => !item)).length;
      this.isDisabled = true;
      if (total === checked) {
        this.isExpand = true;
      } else if (total === unChecked) {
        this.isExpand = false;
      } else {
        this.isDisabled = false;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
  .es-container-header
    border: none
  .es-container-list ul li.removeBorder
    border-left: none
  .header
    border-bottom: none
  .header-subtitle
    margin-left: 1.625rem
  a.disabled
    color: #767676 !important
    cursor:  default
    text-decoration:  none
    pointer-events: none
  .action
    margin-top: 30px
 </style>
